import BusinessTrips from './BusinessTrips';

export default BusinessTrips;
